export const isObjectTruthy = (obj) => {
  //
  if (
    obj &&
    typeof obj === "object" &&
    Object.keys(obj).length > 0 &&
    obj !== null
  )
    return true;
  return false;
};
